// Quest Diagnostics form state and constants.
// Test data is now fetched from FHIR ActivityDefinition resources via useTestCatalog hook.

export const QUEST_QUESTIONNAIRE_ID = 'quest-diagnostics-general-requisition'

export interface QuestWriteInTest {
  testNumber: string
  testName: string
}

export const QUEST_MICROBIOLOGY_SOURCES = [
  'BLOOD',
  'CERVIX',
  'GENITAL',
  'STOOL',
  'THROAT',
  'URINE',
  'WOUND',
] as const

// ---------------------------------------------------------------------------
// Form State
// ---------------------------------------------------------------------------

export interface QuestFormState {
  // Patient Information
  firstName: string
  middleInitial: string
  lastName: string
  sexAtBirth: string
  dateOfBirth: string
  patientId: string
  patientAddress: string
  patientPhone: string
  patientCity: string
  patientState: string
  patientZip: string

  // Provider
  physicianLastName: string
  physicianFirstName: string
  physicianNpi: string
  physicianId: string

  // Diagnosis
  diagnosisText: string

  // Primary Insurance / Billing
  primaryInsuranceCarrier: string
  primaryInsuranceId: string
  primaryGroupNumber: string
  primaryInsuranceAddress: string
  primaryInsuredName: string
  primaryRelationship: string

  // Test Selection — single unified array of test codes
  selectedTests: string[]
  writeInTests: QuestWriteInTest[]

  // Microbiology
  microbiologySources: string[]
  microbiologyOtherSource: string

  // Clinical Information / Comments
  clinicalComments: string

  // Signature
  signatureDate: string
  signatureDataUrl: string

  // Collection Details
  collectionDate: string
  collectionTime: string
  collectionAmPm: string
  isFasting: boolean
  isStat: boolean

  // Lab Facility Selection
  selectedFacilityId: string

  // Provider (auto-populated, hidden)
  organizationName: string
  orgPhone: string
  orgFax: string
  orgAddress: string
  orgCity: string
  orgState: string
  orgZip: string
  orderingProviderName: string
  orderingProviderNpi: string
}

export function createInitialQuestFormState(): QuestFormState {
  return {
    firstName: '',
    middleInitial: '',
    lastName: '',
    sexAtBirth: '',
    dateOfBirth: '',
    patientId: '',
    patientAddress: '',
    patientPhone: '',
    patientCity: '',
    patientState: '',
    patientZip: '',

    physicianLastName: '',
    physicianFirstName: '',
    physicianNpi: '',
    physicianId: '',

    diagnosisText: '',

    primaryInsuranceCarrier: '',
    primaryInsuranceId: '',
    primaryGroupNumber: '',
    primaryInsuranceAddress: '',
    primaryInsuredName: '',
    primaryRelationship: '',

    selectedTests: [],
    writeInTests: [],

    microbiologySources: [],
    microbiologyOtherSource: '',

    clinicalComments: '',

    signatureDate: '',
    signatureDataUrl: '',

    collectionDate: '',
    collectionTime: '',
    collectionAmPm: 'AM',
    isFasting: false,
    isStat: false,

    selectedFacilityId: '',

    organizationName: '',
    orgPhone: '',
    orgFax: '',
    orgAddress: '',
    orgCity: '',
    orgState: '',
    orgZip: '',
    orderingProviderName: '',
    orderingProviderNpi: '',
  }
}
